export const bytesToKB = (bytes: number) => {
    const kb = bytes / 1024;
    if (kb < 1024) return kb.toFixed(0) + " KB";
    const mb = kb / 1024;
    if (mb < 1024) return mb.toFixed(0) + " MB";
    const gb = mb / 1024;
    if (gb < 1024) return gb.toFixed(0) + " GB";
    const tb = gb / 1024;
    return tb.toFixed(0) + " TB";
}